export const OTTIENI_PERITI = "OTTIENI_PERITI"
export const OTTIENI_PERITI_SUCCESS = "OTTIENI_PERITI_SUCCESS"
export const OTTIENI_PERITI_NO_PAGINATE_SUCCESS = "OTTIENI_PERITI_NO_PAGINATE_SUCCESS"
export const COLLEGA_PERITO_ISPETTORE_PUT = "COLLEGA_PERITO_ISPETTORE_PUT"
export const COLLEGA_PERITO_ISPETTORE_PUT_SUCCESS = "COLLEGA_PERITO_ISPETTORE_PUT_SUCCESS"
export const SCOLLEGA_PERITO_ISPETTORE_PUT = "SCOLLEGA_PERITO_ISPETTORE_PUT"
export const SCOLLEGA_PERITO_ISPETTORE_PUT_SUCCESS = "SCOLLEGA_PERITO_ISPETTORE_PUT_SUCCESS"

export const PERITO_DELETE = "PERITO_DELETE"
export const PERITO_DELETE_SUCCESS = "PERITO_DELETE_SUCCESS"